<script setup lang="ts">
  import { wizardConfig } from '@/configs/wizard-element-config'
  import { useFlowConfigStore } from '@/store/flow-config.store.ts'
  import { useToastStore } from '@logistiek-zonder-papier/lzp-library'

  const selectedFieldId = defineModel<string | undefined>('selectedFieldId')

  const { success } = useToastStore()

  const flowConfigStore = useFlowConfigStore()

  async function addField(type: string) {
    const newFlowFieldId = await flowConfigStore.createFlowField(type, selectedFieldId.value)

    if (newFlowFieldId) {
      selectedFieldId.value = newFlowFieldId
    }
    success('Field added successfully.')
  }
</script>

<template>
  <section class="element-selector">
    <h2 class="subtitle">Form elements</h2>
    <div
      class="element-card"
      v-for="item in wizardConfig"
      :key="item.type"
      @click="addField(item.type)"
    >
      <h2 class="title">{{ item.buttonConfig.label }}</h2>
      <p class="description">{{ item.buttonConfig.description }}</p>
    </div>
  </section>
</template>

<style scoped>
  .element-selector {
    display: flex;
    flex-direction: column;
    background-color: var(--colours-grey-1);
    padding: 1rem;
    height: 100%;
    width: 20%;
    user-select: none;
    overflow: auto;
  }

  .subtitle {
    margin: 0 0 1rem;
  }

  .element-card {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    width: 100%;
    max-width: 32rem;
    background-color: var(--colours-grey-1);
    border: 1px solid var(--colours-grey-3);
    box-shadow: 1px 1px 1px 1px var(--colours-grey-3);
    margin-bottom: 1.5rem;
    padding: 1rem;
    border-radius: 0.75rem;
  }

  .element-card:hover {
    transform: translateY(0.125rem);
    box-shadow: none;
  }

  .element-card .title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 0.5rem;
    color: var(--colours-grey-5);
    text-transform: capitalize;
  }

  .element-card .description {
    color: var(--colours-grey-5);
    font-size: 0.75rem;
    margin: 0 0 0.5rem;
  }
</style>
